import { string, object, number, array, bool, date } from "yup";

const validationSchema = object().shape({
  profileCategoryId: string().required("Profile category is required"),
  gender: string().required("Gender is required"),
  language: array(),
  // language: array().min(1, 'Languages is required').required('Languages is required'),
  roleTypeId: string().required("Role is required"),
  isActor: bool(),
  isModel: bool(),
  isInfluencer: bool(),
  experienceCategory: array(),
  ageRange: array().required("Age range is required"),
  characterDescription: string().required("Character description is required"),
  notes: string(),
  shootLocation: string(),
  shootDate: date().nullable(),
  auditionLocation: string(),
  numberOfDays: number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .integer("Must be integer only")
    .min(1, "Must be greater than 0"),
  negotiable: bool(),
  minBudget: number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .integer("Must be integer only")
    .min(1, "Must be greater than 0")
    .when("negotiable", (negotiable, schema) => {
      if (Boolean(negotiable[0])) return schema;
      return schema.test(
        "Compare",
        "Invalid budget range",
        (value, testContext) =>
          (!testContext.parent.maxBudget && !value) ||
          testContext.parent.maxBudget >= value
      );
    }),
  maxBudget: number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .integer("Must be integer only")
    .min(1, "Must be greater than 0")
    .notRequired()
    .nullable()
    .when("negotiable", (negotiable, schema) => {
      if (Boolean(negotiable[0])) return schema;
      return schema.test(
        "Compare",
        "Invalid budget range",
        (value, testContext) =>
          (!testContext.parent.minBudget && !value) ||
          testContext.parent.minBudget <= value
      );
    }),
  payBasis: string(),
  selfTestCheck: string(),
  isExpectedBudget: string(),
  script: string()
    .trim()
    .when("selfTestCheck", (value, schema) => {
      if (value[0] === "yes") {
        return schema.required("Script is required");
      } else {
        return schema;
      }
    }),
});

export default validationSchema;
